import { ProfileData } from '@/types/profile';
import { debugLogger } from '@/utils/debugLogger';
export interface FeedProfile {
  profile_id: string;
  username: string;
  main_photo_url: string;
  profile_photos: string[];
  bio: string;
  age: number;
  gender: string;
  orientation: string;
  role: string;
  city: string;
  state_code: string;
  education: string;
  occupation: string;
  interests: string[];
  relationship_type: string;
  income: string;
  share_income: boolean;
  sponsorship_value: number;
  verification_level: string;
  onboarding_completed: boolean;
  hidden: boolean;
  created_at: string;
  last_login: string;
  is_online: boolean;
  last_seen: string;
  distance_km: number;
  connection_status: string;
  connection_id: string;
  connection_created_at: string;
  height: string;
  body_type: string;
  eye_color: string;
  hair_color: string;
  smoker: string;
  drinker: string;
  tattoos: string;
  piercings: string;
  marital_status: string;
  profile_user_role?: string;
  plan_type: string;
}

// Age calculation removed - now comes directly from backend

export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
};

const deg2rad = (deg: number): number => {
  return deg * (Math.PI / 180);
};

export const transformFeedProfileToProfileData = (feedProfile: FeedProfile): ProfileData => {
  // Temporary diagnostic log
  if (!feedProfile.height) {
    debugLogger.debug('FeedTransform', 'Missing height for profile:', {
      username: feedProfile.username,
      profileId: feedProfile.profile_id,
      height: feedProfile.height
    });
  }
  
  return {
    id: feedProfile.profile_id,
    username: feedProfile.username,
    main_photo_url: feedProfile.main_photo_url,
    photos: feedProfile.profile_photos || [],
    bio: feedProfile.bio,
    birth_date: null, // No longer available from feed data
    age: feedProfile.age || 0, // Age comes directly from backend
    gender: feedProfile.gender,
    orientation: feedProfile.orientation,
    role: feedProfile.role,
    city: feedProfile.city,
    state_code: feedProfile.state_code,
    education: feedProfile.education,
    occupation: feedProfile.occupation,
    interests: feedProfile.interests || [],
    relationship_type: feedProfile.relationship_type,
    income: feedProfile.income,
    share_income: feedProfile.share_income,
    sponsorship_value: feedProfile.sponsorship_value,
    verification_level: feedProfile.verification_level,
    onboarding_completed: feedProfile.onboarding_completed,
    hidden: feedProfile.hidden,
    latitude: null, // No longer available from feed data
    longitude: null, // No longer available from feed data
    created_at: feedProfile.created_at,
    last_login: feedProfile.last_login,
    is_online: feedProfile.is_online,
    last_seen: feedProfile.last_seen,
    distance: feedProfile.distance_km,
    connection_status: feedProfile.connection_status,
    connection_id: feedProfile.connection_id,
    connection_created_at: feedProfile.connection_created_at,
    height: feedProfile.height,
    body_type: feedProfile.body_type,
    eye_color: feedProfile.eye_color,
    hair_color: feedProfile.hair_color,
    smoker: feedProfile.smoker,
    drinker: feedProfile.drinker,
    tattoos: feedProfile.tattoos,
    piercings: feedProfile.piercings,
    marital_status: feedProfile.marital_status,
    user_role: feedProfile.profile_user_role || 'user',
    plan_type: (feedProfile.plan_type || 'sponsor_free') as ProfileData['plan_type']
  };
};
